var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-item"},[_c('span',{staticClass:"form-item__label text-color--info"},[_vm._v(" "+_vm._s(_vm.label)+" ")]),_c('div',{staticClass:"form-item__element"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }